import { render, staticRenderFns } from "./CookieSettingsLink.vue?vue&type=template&id=e389c38e"
import script from "./CookieSettingsLink.vue?vue&type=script&lang=js"
export * from "./CookieSettingsLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports